var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"6","sm":"6"}},[_c('payin-per-month')],1),_c('b-col',{attrs:{"lg":"6","sm":"6"}},[_c('user-per-month')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }